export enum RoomCleaningStatus {
  Clean = 'clean',
  NeedDeepCleaning = 'needDeepCleaning',
  NeedStandardCleaning = 'needStandardCleaning',
  NeedExtraCleaning = 'needExtraCleaning',
}
